import * as React from "react";
import { IconCollection } from "./IconCollection.js";
export { Icon, IconCollection };
/**
 * Иконки.
 * 
 * В теме присутствуют 2 типа иконок: шрифтовые и графические.
 * 
 * Большинство иконок в теме шрифтовые монохромные.
 * Их цвет можно менять с помощью CSS свойства `color`.
 * Иконки собраны в шрифт `RowebIcon`.
 * 
 * Иконка `ru` (кружок с флагом) цветная и загружается в формате SVG.
 * 
 * Реализована простая анимация для вращающихся иконок (см. иконку `loading`).
 * 
 * Список доступных иконок и их имён можно посмотреть в файле:
 * [frame/IconCollection.html][icon]
 * 
 * [icon]: https://uits-demo2.roweb.online/new-react-app/v24.3.19/#/icon
 * @summary Иконки.
 * @param {Object} props - Атрибуты элемента.
 * @param {string} props.name - Имя иконки.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * <p>
 *   Шрифтовая иконка: <Icon name="home"/>
 * </p>
 * <p>
 *   Цветная иконка: <Icon name="ru"/>
 * </p>
 * <p>
 *   Вращающаяся иконка: <Icon name="loading"/>
 * </p>
 * <p>
 *   Произвольная вращающаяся иконка:
 *   <Icon name="home" className="spin_icon"/>
 * </p>
 * <p>
 *   Произвольного размера, цвета и оформления:<br/>
 *   <Icon name="home" className="my_icon spin_icon"/>
 *   <style>
 *     .my_icon
 *     {"{"}
 *       font-size: 32px;
 *       color: red;
 *       background: green;
 *       padding: 32px;
 *       border-radius: 48px;
 *     {"}"}
 *   </style>
 * </p>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Icon(
  {
    name = "question",
    className
  }) {
  let classList = IconCollection[name];
  if (!classList) classList = IconCollection.question;
  if (className) classList = classList + " " + className;//[...classList, className];
  const fullClassName = classList;//.join(" ");
  return <i role="img" aria-hidden="true" className={fullClassName}></i>;
}
